import { UploadFile } from 'antd';
import { http, defaultConfig, SAMIN_KEY, getHelpDeskUrl, SAMIN_WRITE_KEY } from './http';

export async function fetchIssues(username: string, page = 1, limit = 100, key: string = undefined) {
  const baseURL = getHelpDeskUrl();
  const url = `/issues.json?key=${key ?? SAMIN_KEY}&status_id=*&cf_72=${username}&sort=start_date:desc&page=${page}&limit=${limit}`;
  return (await http.get(url, defaultConfig(baseURL))).data;
}

export async function fetchStatuses(key: string = undefined) {
  const baseURL = getHelpDeskUrl();
  const url = `/issue_statuses.json?key=${key ?? SAMIN_KEY}`;
  return (await http.get(url, defaultConfig(baseURL))).data;
}

export async function fetchCustomFields(key: string = undefined) {
  const baseURL = getHelpDeskUrl();
  const url = `/custom_fields.json?key=${key ?? SAMIN_KEY}&limit=100`;
  return (await http.get<{ custom_fields: RedmineTypeEntity[] }>(url, defaultConfig(baseURL))).data;
}

export async function fetchProjects(typeId: number | string, key: string = undefined) {
  const baseURL = getHelpDeskUrl();
  const url = `/projects.json?key=${key ?? SAMIN_KEY}&cf_155=${typeId}&limit=100`;
  return (await http.get<{
    limit: number;
    offset: number;
    projects: RedmineProjectEntity[];
    total_count: number;
  }>(url, defaultConfig(baseURL))).data;
}

export async function fetchProjectCategories(projectId: number, key: string = undefined) {
  const baseURL = getHelpDeskUrl();
  const url = `/projects/${projectId}/issue_categories.json?key=${key ?? SAMIN_KEY}&limit=100`;
  return (await http.get<{
    issue_categories: RedmineCategoryEntity[];
    total_count: number;
  }>(url, defaultConfig(baseURL))).data;
}

export async function uploadAttachment(file: UploadFile, key: string = undefined) {
  const baseURL = getHelpDeskUrl();
  const url = `/uploads.json?key=${key ?? SAMIN_WRITE_KEY}&filename=${file.name}`;
  return (await http.post(url, file, defaultConfig(baseURL, {
    auth: false,
    headers: {
      'Content-Type': 'application/octet-stream',
      'X-Redmine-API-Key': 'e461770de1c4e1535f268744630c8ff7915e86ba',
    }
  }))).data;
}

export async function createIssue(issue: Partial<RedmineIssueEntity | any>, key: string = undefined) {
  const baseURL = getHelpDeskUrl();
  const url = `/issues.json?key=${key ?? SAMIN_WRITE_KEY}`;
  return (await http.post(url, { issue }, defaultConfig(baseURL))).data;
}

export async function getIssueById(id: number, key: string = undefined) {
  const baseURL = getHelpDeskUrl();
  const url = `/issues/${id}.json?key=${key ?? SAMIN_KEY}&include=attachments,journals`;
  return (await http.get(url, defaultConfig(baseURL))).data;
}

export async function updateIssueNotes(issueId: number, payload: any, key = undefined) {
  const baseURL = getHelpDeskUrl();
  const url = `/issues/${issueId}.json?key=${key ?? SAMIN_KEY}`;
  return (await http.put(url, payload, defaultConfig(baseURL))).data;
}
